import {
  CircleMarker,
  DriverMarker,
  Marker,
  ProviderMarker,
  ReadyForHaulageMarker,
  RouteMarker,
} from "src/app/map-icons"
import { MarkerTypes } from "src/features/shared-module/constants"
import { RouteSummaryRaw, StopFeature } from "src/features/shared-module/models"

export const getFirstAndLastPositions = (
  routeSummaryModel: RouteSummaryRaw,
): {
  firstStop: StopFeature
  lastStop: StopFeature
} => {
  const firstStopID =
    routeSummaryModel.routes.features[0].attributes.FirstStopID
  const lastStopID = routeSummaryModel.routes.features[0].attributes.LastStopID
  const firstPosition: StopFeature = routeSummaryModel.stops.features.find(
    (e) => e.attributes.ObjectID === firstStopID,
  ) as StopFeature
  const lastPosition: StopFeature = routeSummaryModel.stops.features.find(
    (e) => e.attributes.ObjectID === lastStopID,
  ) as StopFeature
  return {
    firstStop: firstPosition,
    lastStop: lastPosition,
  }
}

export const getMarkerByType = (
  color: string,
  type: MarkerTypes,
  orderSequence: number | null = null,
) => {
  switch (type) {
    case MarkerTypes.ROUTE_ORDER:
      return (
        <RouteMarker color={color} orderSequence={orderSequence as number} />
      )
    case MarkerTypes.UNASSIGNED_ORDER:
      return <ReadyForHaulageMarker />
    case MarkerTypes.CIRCLE:
      return <CircleMarker color={color} />
    case MarkerTypes.PROVIDER:
      return <ProviderMarker color={color} />
    case MarkerTypes.INDIVIDUAL_ORDER:
      return <Marker color={color} />
    case MarkerTypes.DRIVER:
      return <DriverMarker color={color} />
    default:
      return null
  }
}
